export type SVGElementProps = React.SVGProps<SVGSVGElement>;

export type ReducerAction<Type extends string, Payload extends any = any> = {
  type: Type;
  payload: Payload;
};

export enum FormaPagamento {
  CreditoRecorrencia = "CREDITO_REC",
  Isento = "ISENTO",
}

export type PreRegistroCliente = {
  id: string;
  createdAt: string;
  updatedAt?: string | null;
  cpf: string;
  nome: string;
  telefone?: string | null;
  planoId: number;
  clienteId?: number | null;
  propostaId: string;
  vendaId?: number;
  vendedorId: number;
  meiContratante: boolean;
  action: "include" | "exclude";
  observacao?: string | null;
  vendedor?: any;
  venda?: any;
  proposta?: any;
};
